module.exports = __webpack_public_path__ + "static/media/ic_user_profiles.d79af0b8.svg";